import React from 'react';
import { Link } from 'react-router-dom';

import './aboutme.css';

const AboutMe = () => {
        return (
                <div className="section sectionBackground" id="aboutMe">
                        <div className="viewport">
                                <div className='aboutMeItem' id='qualifications'>
                                        <h1>Über mich</h1>
                                        <p className="sectionLead">
                                                Ich nehme mir Zeit f&uuml;r Anamnese und Aufkl&auml;rung &ndash; und erstelle einen Plan,
                                                der zu Ihren Beschwerden und Ihrem Alltag passt.
                                        </p>
                                        <h2>Ausbildung &amp; Schwerpunkte</h2>
                                        <ul>
                                                <li>Ausbildung zur Heilpraktikerin an der Heilpraktikerschule Campus Regensburg</li>
                                                <li>Spezialisierung in: TCM, Komplexhomöopathie, Kinesiologie, Wirbelsäulentherapie und in Frequenzbehandlungsmethoden</li>
                                                <li>Aktive Mitgliedschaft beim Bund Deutscher Heilpraktiker und Naturheilkundiger e.V.</li>
                                        </ul>
                                        <br />
                                        <p>
                                                So l&auml;uft ein Termin meist ab: Anamnese &rarr; Untersuchung und Auswahl der Methoden &rarr;
                                                gemeinsamer Therapieplan.
                                        </p>
                                        <div className="ctaRow">
                                                <Link className="buttonPrimary" to="/#page-booking">Ersttermin buchen</Link>
                                                <Link className="buttonSecondary" to="/#page-contact">Frage stellen</Link>
                                        </div>
                                </div>
                                <div className='aboutMeItem' id='aboutMeImage'>

                                </div>
                        </div>
                </div>
        )
}
export default AboutMe;